export function createFadeOverlay() {
  const el = document.createElement('div');
  el.className = 'fade-overlay';
  el.style.opacity = '0';
  el.style.pointerEvents = 'none';
  document.body.appendChild(el);

  function animateOpacity(from, to, ms) {
    return new Promise((resolve) => {
      const t0 = performance.now();
      el.style.pointerEvents = to > 0.5 ? 'auto' : 'none';
      function frame(now) {
        const u = Math.min(1, (now - t0) / ms);
        el.style.opacity = String(from + (to - from) * u);
        if (u < 1) requestAnimationFrame(frame);
        else {
          el.style.opacity = String(to);
          el.style.pointerEvents = to > 0.5 ? 'auto' : 'none';
          resolve();
        }
      }
      requestAnimationFrame(frame);
    });
  }

  return {
    fadeOut(ms = 400) {
      return animateOpacity(Number(el.style.opacity) || 0, 1, ms);
    },
    fadeIn(ms = 400) {
      return animateOpacity(Number(el.style.opacity) || 1, 0, ms);
    },
  };
}
